import { Link } from 'react-router-dom';
import { featuredCollections } from '@/mocks/videos';

export default function FeaturedCollections() {
  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-folder-line text-accent-600 text-sm"></i>
              </span>
              <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">Collections</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选专题
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCollections.map((collection) => (
            <Link
              key={collection.id}
              to="/category/remen-baoliao"
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-[220px]"
            >
              <img
                src={collection.image}
                alt={collection.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-background-50 font-heading text-lg font-bold mb-1">
                  {collection.title}
                </h3>
                <div className="flex items-center gap-2">
                  <p className="text-background-300 text-xs">{collection.description}</p>
                  <span className="text-accent-400 text-xs font-medium">{collection.count}个视频</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}